// extracted by mini-css-extract-plugin
export default {"RowFilters":"VerTodosProcesos_RowFilters__pIG5N"};